var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkyBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1189_12444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60911 17.1643L24.1995 17.1644M24.1995 17.1644L17.7934 10.7582M24.1995 17.1644L17.7934 23.5705",
    stroke: "#63ADF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1189_12444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.159,
    height: 24.159,
    fill: "white",
    transform: "translate(17.082 0.0820312) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyBlueArrow);
export default __webpack_public_path__ + "static/media/sky-blue-arrow.50336ddd2f1c6680c8745e34133bcd6b.svg";
export { ForwardRef as ReactComponent };